import { getSystemIcon, SystemIcon } from '@helpers/icons';
import { withMotion } from '@hoc/withMotion';
import SvgBackToTop from '@img/back-to-top.svg';
import BackgroundImage from '@img/backgrounds/footer-background.png';
import SvgBSALogo from '@img/BSA-logo-inverted.svg';
import SvgLogo from '@img/logo-inverted.svg';
import * as React from 'react';
import { FocusRing } from 'react-aria';
import S from './Footer.styles';
import UmbracoForm from '@stories/Components/Misc/Forms/UmbracoForm/UmbracoForm';
import { getSrcs } from '@helpers/image';
const Footer = (props) => {
    const [open, setOpen] = React.useState(-1);
    function highlightWord(text) {
        return text.replace(/\*(.*?)\*/g, '<span>$1</span>');
    }
    function scrollToTop() {
        window.scrollTo({ top: 0, left: 0, behavior: 'smooth' });
    }
    return (React.createElement(S.Container, null,
        React.createElement(S.BackgroundImageContainer, null,
            React.createElement(S.BackgroundImage, { src: BackgroundImage, alt: "", role: "presentation" })),
        React.createElement(S.Inner, null,
            React.createElement(FocusRing, { focusRingClass: "focus-ring" },
                React.createElement(S.BackToTopBtn, { type: "button", "aria-label": props.translations?.['global.footer.scrollTop'], onClick: () => {
                        scrollToTop();
                    } },
                    React.createElement(S.BackToTopText, null,
                        React.createElement(SvgBackToTop, null)),
                    React.createElement(S.BackToTopIcon, null, getSystemIcon(SystemIcon.ArrowDownThin)))),
            React.createElement(S.QuoteArea, null,
                props.quote?.quote && (React.createElement(S.Quote, { dangerouslySetInnerHTML: { __html: highlightWord(props.quote?.quote) } })),
                React.createElement(S.Skew, null),
                React.createElement(S.QuoteInfo, null,
                    props.quote?.profession && (React.createElement(S.QuoteProfession, null, props.quote?.profession)),
                    props.quote?.name && React.createElement(S.QuoteName, null, props.quote?.name))),
            React.createElement(S.LeftColumn, null,
                React.createElement(S.LogoArea, null,
                    React.createElement(FocusRing, { focusRingClass: "focus-ring" },
                        React.createElement(S.MainLogo, { href: "/", "aria-label": "Home", target: "_self" },
                            React.createElement(SvgLogo, null))),
                    React.createElement(S.Skew, null),
                    React.createElement(FocusRing, { focusRingClass: "focus-ring" },
                        React.createElement(S.BsaLogo, { href: props.bsaLink?.url, "aria-label": props.bsaLink?.text, target: props.bsaLink?.target },
                            React.createElement(SvgBSALogo, null)))),
                React.createElement(S.FormArea, null,
                    props.newsletterSignup.title && (React.createElement(S.NewsletterTitle, null, props.newsletterSignup.title)),
                    props.newsletterSignup.content && (React.createElement(S.NewsletterContent, null, props.newsletterSignup.content)),
                    React.createElement(UmbracoForm, null),
                    React.createElement(S.Form, { dangerouslySetInnerHTML: { __html: props.newsletterSignup.formHtml } }))),
            React.createElement(S.RightColumn, null,
                React.createElement(S.FooterLinks, null, props.links.map((group, i) => (React.createElement("div", { key: `footer-links-${group.id}` },
                    React.createElement(S.LinkListHeader, { "data-open": open === i, onClick: () => {
                            if (open === i) {
                                setOpen(-1);
                            }
                            else {
                                setOpen(i);
                            }
                        }, "aria-controls": `footer-links-${group.id}` },
                        React.createElement("h2", null, group.label.text),
                        getSystemIcon(SystemIcon.Chevron)),
                    React.createElement(S.LinkListHeader, { as: 'span' },
                        React.createElement("h2", null, group.label.text)),
                    React.createElement(S.LinkList, { id: `footer-links-${group.id}`, variants: {
                            initial: {
                                height: 0,
                                marginBottom: 0,
                                transitionEnd: { visibility: 'hidden' },
                            },
                            open: { height: 'auto', marginBottom: 24, visibility: 'visible' },
                        }, animate: open === i ? 'open' : 'initial' },
                        group.label.url && (React.createElement("li", { "data-mobile-only": true },
                            React.createElement("a", { href: group.label.url, target: group.label.target },
                                group.label.text,
                                " ",
                                getSystemIcon(SystemIcon.Chevron)))),
                        group.links.map((link, j) => (React.createElement("li", { key: `footer-links-${group.id}-${j}` },
                            React.createElement("a", { href: link.url, target: link.target },
                                link.text,
                                " ",
                                getSystemIcon(SystemIcon.Chevron)))))))))),
                React.createElement(S.BrandList, null,
                    React.createElement(S.LinkListHeader, { "data-open": open === 1000, onClick: () => {
                            if (open === 1000) {
                                setOpen(-1);
                            }
                            else {
                                setOpen(1000);
                            }
                        }, "aria-controls": `footer-links-${props.brandList.title}` },
                        React.createElement("h2", null, props.brandList.title),
                        getSystemIcon(SystemIcon.Chevron)),
                    React.createElement(S.LinkListHeader, { as: 'span' },
                        React.createElement("h2", null, props.brandList.title)),
                    React.createElement(S.BrandListImages, { id: `brand-links-${props.brandList.title}`, variants: {
                            initial: {
                                height: 0,
                                marginBottom: 0,
                                transitionEnd: { visibility: 'hidden' },
                            },
                            open: { height: 'auto', marginBottom: 0, visibility: 'visible' },
                        }, animate: open === 1000 ? 'open' : 'initial' }, props.brandList.brandImages.map((brand, i) => (React.createElement("li", { key: `brand-list-item-${i}` },
                        React.createElement("a", { href: brand.cta.url, target: brand.cta.target },
                            React.createElement(S.BrandListImage, { src: getSrcs(brand.image, 222, 160, 3).src, srcSet: getSrcs(brand.image, 222, 160, 3).srcSet, alt: brand.image.altText, role: brand.image.altText ? undefined : 'presentation', loading: 'lazy' })))))))),
            React.createElement(S.BaseArea, null,
                React.createElement(S.BaseLeft, null,
                    props.legalText && React.createElement(S.LegalText, null, props.legalText),
                    props.legalText2 && React.createElement(S.LegalText2, null, props.legalText2),
                    props.charityText && React.createElement(S.LegalText2, null, props.charityText)),
                React.createElement(S.BaseRight, null,
                    React.createElement(S.SocialLinks, null,
                        React.createElement(S.SocialLinkList, null, props.socialLinks &&
                            props.socialLinks.map((link) => (React.createElement(FocusRing, { key: `social-link-${link.cta.text}`, focusRingClass: "focus-ring" },
                                React.createElement(S.SocialLink, { href: link.cta.url, target: "_blank", title: link.cta.text }, getSystemIcon(link.icon))))))),
                    React.createElement(S.LegalLinks, null, props.legalLinks.map((link) => (React.createElement(S.LegalLink, { key: `legal-link-${link.text}` },
                        React.createElement(FocusRing, { focusRingClass: "focus-ring" },
                            React.createElement(S.LegalLinkAnchor, { href: link.url, target: "_blank" }, link.text)))))))))));
};
export default withMotion(Footer);
